/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import { Autocomplete, AutocompleteProps, Box, Paper, TextField, Typography } from '@mui/material';
import React from 'react';

import { Option } from 'src/types/common/option';

import Iconify from '../iconify';
import Scrollbar from '../scrollbar';

export interface CustomAutocompleteProps extends Omit<AutocompleteProps<Option, true, true, false>, 'renderInput'> {
  selectedOptions?: Option[] | undefined;
  options: Option[];
  handleSelectOption: (option: any) => void;
  placeholder: string;
  disableTags?: boolean;
}

export default function CustomAutocomplete(Props: CustomAutocompleteProps) {
  // const { } = useCustomAutocomplete();
  return (
    <div data-testid="customAutocomplete-render-test">
      <Autocomplete
        {...Props}
        disablePortal
        value={Props.selectedOptions}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={Props.options}
        renderTags={Props.disableTags ? () => null : undefined}
        onChange={(event: any, option: any | null) => {
          Props.handleSelectOption(option);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              sx: {
                borderRadius: 100,
                '&.MuiOutlinedInput-root': { p: 0 },
              },
              ...params.InputProps,
            }}
            inputProps={{
              style: {
                padding: '8px 16px',
              },
              ...params.inputProps,
            }}
            placeholder={Props.placeholder}
            fullWidth
          />
        )}
        renderOption={(props, option, { selected }) => (
          <Box
            component="li"
            {...props}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 1.2,
              cursor: 'pointer',
              width: '100%',
              backgroundColor: 'white',
              borderBottom: '1px solid #ddd',
              borderRadius: '0px !important',
              '&[aria-selected="true"]': {
                backgroundColor: 'white !important',
              },
              '&.Mui-focused': {
                backgroundColor: 'greyScale.50 !important',
                borderRadius: 0,
              },
            }}
          >
            <Typography typography="body-md" width="100%" color="greyScale.300" py={1.2} pl={1.2}>
              {option.label}
            </Typography>

            {/* {option.icon && <Iconify icon={option.icon} color="black" width={24} height={24} style={{ marginRight: 8, color: 'black' }} />} */}

            {selected && <Iconify icon="ri:check-line" color="feedback.success" width={20} />}
            <Box width={10} />
          </Box>
        )}
        PaperComponent={(props, ref) => (
          <Paper
            {...props}
            sx={{
              width: '100%',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: ' 0px 2px 20px #00000033',
              overflow: 'visible',
              py: 1.2,
            }}
          >
            <Box>{props.children}</Box>
          </Paper>
        )}
        ListboxComponent={(props) => (
          <Box
            {...props}
            sx={{
              overflow: 'hidden !important',
            }}
          >
            <Scrollbar sx={{ maxHeight: 280 }}>{props.children}</Scrollbar>
          </Box>
        )}
      />
    </div>
  );
}
